export default {
  lo4art_Api:"https://api.lo4art.com/",
  //lo4art_Api:"http://localhost:8081/",
  lo4art_Cdm:"https://cdm.lo4art.com/",
  sendgrid:"https://api.sendgrid.com/v3/mail/send"
}
